module.exports = __webpack_public_path__ + "media/images/txhdr-fd6b67e331d23023e72ea7a846c640ed.png";